/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  ADD_BANK_TO_ASSET,
  ADD_BANK_TO_ASSET_SUCCESS,
  ADD_BANK_TO_ASSET_FAILURE,
  REMOVE_BANK_FROM_ASSET,
  REMOVE_BANK_FROM_ASSET_SUCCESS,
  REMOVE_BANK_FROM_ASSET_FAILURE,
} from "../actions/actionTypes";

import {
  setLoadingState,
  setSuccessResponse,
  setErrorResponse,
} from "./reducerUtils";

const initialState = {
  addBankToAsset: {
    data: null,
    state: "INIT",
    error: null,
  },
  removeBankFromAsset: {
    data: null,
    state: "INIT",
    error: null,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_BANK_TO_ASSET:
      return setLoadingState(state, "addBankToAsset");
    case ADD_BANK_TO_ASSET_SUCCESS:
      return setSuccessResponse(state, action, "addBankToAsset");
    case ADD_BANK_TO_ASSET_FAILURE:
      return setErrorResponse(state, action.errResp, "addBankToAsset");
    case REMOVE_BANK_FROM_ASSET:
      return setLoadingState(state, "removeBankFromAsset");
    case REMOVE_BANK_FROM_ASSET_SUCCESS:
      return setSuccessResponse(state, action, "removeBankFromAsset");
    case REMOVE_BANK_FROM_ASSET_FAILURE:
      return setErrorResponse(state, action.errResp, "addBankToAsset");

    default:
      return state;
  }
}
